import { useEffect } from 'react'
import useRouter from '../hooks/useRouter'
import useAccount from '../hooks/useAccount'

export default function AgentPage() {
  const router = useRouter()
  const account = useAccount()
  const customer = router.params.customer || account.customer?.name || ''

  useEffect(() => {
    if (customer) {
      router.navigate('agent-new', { customer })
    }
  }, [customer, router])

  return null
}
